import React from 'react';
import ReactDOM from 'react-dom/client';
// Import base layout styles (App, app-body, app-main, sidebar layout)
import './index.css';
// Import our standardized CSS files
import './styles/themes.css';
import './styles/common.css';
import './styles/animations.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { runVersionGuard } from './utils/versionCheck';

// CARQ-45：避免重新整理瀏覽器時殘影顯示「上一次瀏覽的另一張報價單/專案」。
// Safari／部分 Chrome 情境會啟用 bfcache（back/forward cache），按下重新整理時
// 會先「秒回放」上一份頁面 DOM 才執行 JS。在 bfcache 還原（event.persisted=true）
// 時強制 reload 一次，可確保畫面從零開始重新掛載，不會閃出舊報價單的內容。
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

// CARQ-72：過期 bundle 自癒。啟動時比對「跑的 bundle 指紋」與 GET /api/version 的線上指紋，
// 不一致代表瀏覽器／Cloudflare 仍服務修正前快取的舊版 index.html（指向舊 JS chunk，按鈕
// 看似沒反應）→ 自動帶 cache-bust query 整頁重載，把 Bridget 手動加 query 的繞法自動化。
// 在 render 前呼叫：此時尚未進入任何編輯流程，重載不會毀掉未存資料。詳見 utils/versionCheck.js。
runVersionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
